/** Render unexpected structured section content as readable text, not React children. */
export function proposalSectionText(value: unknown): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value.map(proposalSectionText).filter(Boolean).join("\n\n");
  if (typeof value === "object") {
    return Object.entries(value).map(([key, item]) => {
      const label = key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ");
      return `${label.charAt(0).toUpperCase() + label.slice(1)}: ${proposalSectionText(item)}`;
    }).join("\n\n");
  }
  return String(value);
}

export function normalizeProposalSections<T>(value: T): T {
  if (!value || typeof value !== "object") return value;
  const sectionKeys = new Set([
    "companyIntroduction", "propertyAssessment", "surfaceAndMethodPlan", "scopeOfWork", "serviceSchedule", "chemistryAndEquipment", "costBreakdown", "safetyAndCompliance", "termsAndConditions",
    "pestIdentification", "treatmentPlan", "chemicalAndProductDetails", "propertyOverview", "crewAndEquipmentPlan", "materialsAndPlants", "maintenancePlan", "projectScope", "workPlan", "projectTimeline", "materialSpecifications",
    "executiveSummary", "threatAssessment", "riskImpact", "staffingRecommendation", "securityActions", "implementationPlan", "expectedOutcomes", "crimeDataSummary", "securityMeasures", "proposalSummary", "postOrders",
    "caseOverview", "methodology", "deliverables", "timeline", "eventOverview", "crewPlan", "shiftSchedule", "laborCostBreakdown", "cleaningSchedule", "staffingEstimate", "pricingBreakdown", "qualityAssurance", "projectOverview", "laborAndCrewPlan", "materialsTakeoff", "projectSchedule",
  ]);
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, sectionKeys.has(key) ? proposalSectionText(item) : item])) as T;
}